const getExtendedTimes = (times) => {
  return times
    .reduce((accumulator, time) => {
      const hour = time.substring(0, 2);
      if (!accumulator.includes(hour)) {
        accumulator.push(hour);
      }

      return accumulator;
    }, [])
    .flatMap((time) => {
      const hour = time.substring(0, 2);

      const minutes = [
        `${hour}00`,
        `${hour}05`,
        `${hour}10`,
        `${hour}15`,
        `${hour}20`,
        `${hour}25`,
        `${hour}30`,
        `${hour}35`,
        `${hour}40`,
        `${hour}45`,
        `${hour}50`,
        `${hour}55`,
      ];

      return minutes;
    })
    .sort();
};

const getMidHours = (startTime, endTime) => {
  const startTimeHour = parseInt(startTime.substring(0, 2), 10);
  const endTimeHour = parseInt(endTime.substring(0, 2), 10);

  const midHours = [];

  for (let index = startTimeHour; index < endTimeHour; index++) {
    let midHourToString = '';
    if (index < 10) {
      midHourToString = `0${index}00`;
    } else {
      midHourToString = `${index}00`;
    }
    midHours.push(midHourToString);
  }

  return midHours;
};

const assignColumns = (events) => {
  const toMinutes = (t) => parseInt(t.substring(0, 2), 10) * 60 + parseInt(t.substring(2), 10);

  const sorted = [...events].sort((a, b) => {
    const diff = toMinutes(a.startTime) - toMinutes(b.startTime);
    return diff !== 0 ? diff : toMinutes(a.endTime) - toMinutes(b.endTime);
  });

  const result = [];
  let cluster = [];
  let clusterEnd = -Infinity;

  const flushCluster = () => {
    if (cluster.length === 0) return;

    const columnEndTimes = []; // end time currently occupying each column
    const withColumns = cluster.map((ev) => {
      const start = toMinutes(ev.startTime);
      const end = toMinutes(ev.endTime);

      let columnIndex = columnEndTimes.findIndex((endTime) => endTime <= start);
      if (columnIndex === -1) {
        columnIndex = columnEndTimes.length;
        columnEndTimes.push(end);
      } else {
        columnEndTimes[columnIndex] = end;
      }
      return { ev, columnIndex };
    });

    const totalColumns = columnEndTimes.length;
    withColumns.forEach(({ ev, columnIndex }) => {
      result.push({ ...ev, column: columnIndex, totalColumns });
    });

    cluster = [];
  };

  sorted.forEach((ev) => {
    const start = toMinutes(ev.startTime);
    const end = toMinutes(ev.endTime);

    if (cluster.length === 0 || start < clusterEnd) {
      cluster.push(ev);
      clusterEnd = Math.max(clusterEnd, end);
    } else {
      flushCluster();
      cluster.push(ev);
      clusterEnd = end;
    }
  });
  flushCluster();

  return result;
};

module.exports = { getMidHours, getExtendedTimes, assignColumns };
